import LeafletDefaults from 'views/utils/LeafletMap/utils/LeafletDefaults';
import CourseAlertMessage from '../../../../../Courses/Components/CourseAlertMessage/CourseAlertMessage';
var util = function() {
    return this;
};

util.PopularityRouteTypes = {
    ROAD_BIKING: 'ROAD_CYCLING',
    ROAD_CYCLING: 'ROAD_CYCLING',
    MOUNTAIN_BIKING: 'MOUNTAIN_BIKING',
    GRAVEL_BIKING: 'GRAVEL_BIKING',
    GRAVEL_CYCLING: 'GRAVEL_BIKING',
    MIXED_SURFACE: 'MIXED_SURFACE',
    RUNNING: 'RUNNING',
    TRAIL_RUNNING: 'TRAIL_RUNNING',
    HIKING: 'HIKING'
};

util.RoundTripRouteTypes = {
    ROAD_BIKING: 'ROAD_CYCLING',
    ROAD_CYCLING: 'ROAD_CYCLING',
    MOUNTAIN_BIKING: 'MOUNTAIN_BIKING',
    GRAVEL_BIKING: 'GRAVEL_BIKING',
    GRAVEL_CYCLING: 'GRAVEL_BIKING',
    MIXED_SURFACE: 'MIXED_SURFACE',
    RUNNING: 'RUNNING',
    TRAIL_RUNNING: 'TRAIL_RUNNING',
    HIKING: 'HIKING',
    OTHER: 'MIXED_SURFACE'
};

/* This represents the course types supported by Heatmap Service */
util.SupportedPopularityTypes = {
    ROAD_BIKING: 'ROAD_CYCLING',
    ROAD_CYCLING: 'ROAD_CYCLING',
    MOUNTAIN_BIKING: 'MOUNTAIN_BIKING',
    GRAVEL_BIKING: 'GRAVEL_BIKING',
    GRAVEL_CYCLING: 'GRAVEL_BIKING',
    RUNNING: 'RUNNING',
    TRAIL_RUNNING: 'TRAIL_RUNNING',
    HIKING: 'HIKING'
};

// TODO: START - Remove after popularity routing turned on for running.
util.allowRoutingForRunning = false;

util.isRunningSupportedPopularityTypes = function(popularityType) {
    return popularityType.indexOf('RUNNING') > -1;
};

util.isPopularityRoutingSupported = function(courseType) {
    if (courseType && this.SupportedPopularityTypes[courseType.toUpperCase()]) {
        if (this.isRunningSupportedPopularityTypes(courseType.toUpperCase()) && !this.allowRoutingForRunning) {
            return false;
        }
        return true;
    }
    return false;
};
// TODO: END - Remove after popularity routing turned on for running.

util.ErrorCodes = {
    GENERIC: 'GENERIC',
    ROUTE_TO_LONG: 'ROUTE_TO_LONG',
    ROUTE_TO_FAR_FROM_ROADS: 'ROUTE_TO_FAR_FROM_ROADS',
    NO_ROUTING_DATA: 'NO_ROUTING_DATA',
    PR_GENERIC: 'PR_GENERIC',
    PR_NO_ROUTING_DATA: 'PR_NO_ROUTING_DATA'
};

util.MAP_LAYER_TYPES = {
    ROAD: 'ROAD',
    SATELLITE: 'SATELLITE',
    TERRAIN: 'TERRAIN',
    HYBRID: 'HYBRID'
};

util.TRANSIT_MODE = {
    CYCLING: 'CYCLING',
    PEDESTRIAN: 'PEDESTRIAN'
};

util.MapProviders = {
    GOOGLE: 'google',
    OSM: 'osm',
    HERE: 'here',
    /*keept bing because some users might still have this preference set and we need to check*/
    BING: 'bing',
    BAIDU: 'baidu'
};

util.HereMapTileTypeMapping = {
    road: 'explore.day',
    satellite: 'satellite.day',
    terrain: 'terrain.day',
    hybrid: 'explore.satellite.day'
};

util.DirectionServices = {
    GOOGLE: 'GOOGLE',
    OSM: 'OSM',
    GARMIN: 'GARMIN',
    BAIDU: 'BAIDU'
};

util.HeatMapServices = {
    GARMIN: 'GARMIN'
};

util.TaskTypes = {
    START: 'START',
    END: 'END',
    SPLIT: 'SPLIT',
    CUSTOM: 'CUSTOM'
};

util.ProviderToNameMapping = {
    google: 'Google',
    here: 'here',
    osm: 'OpenStreetMap',
    baidu: 'Baidu'
};

util.RoutingErrorMapping = {
    GENERIC: {
        key: 'course_map_alert_error_retrieving_route',
        alertType: CourseAlertMessage.AlertType.Warning
    },
    ROUTE_TO_LONG: {
        key: 'course_route_to_long',
        alertType: CourseAlertMessage.AlertType.Info
    },
    ROUTE_TO_FAR_FROM_ROADS: {
        key: 'course_route_to_far_from_roads',
        alertType: CourseAlertMessage.AlertType.Info
    },
    NO_ROUTING_DATA: {
        key: 'course_map_alert_error_retrieving_route',
        alertType: CourseAlertMessage.AlertType.Warning
    },
    PR_GENERIC: {
        key: 'course_pr_service_error',
        alertType: CourseAlertMessage.AlertType.Warning
    },
    PR_NO_ROUTING_DATA: {
        key: 'course_pr_no_routing_data',
        alertType: CourseAlertMessage.AlertType.Warning
    }
};

util.DrawingMethods = {
    SNAP_TO_ROAD: 'snap',
    POPULAR_ROUTES: 'popular',
    FREEHAND: 'free'
};

util.CoordinateSystem = {
    WGS84: 'WGS84',
    GCJ02: 'GCJ02',
    BD09: 'BD09'
};

util.LeafletDefaults = LeafletDefaults;

//METHODS
util.extend = function(obj, properties) {
    for (var p in properties) {
        if (p && properties.hasOwnProperty(p)) {
            obj[p] = properties[p];
        }
    }
};

export default util;
